import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "email" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { for: "password" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.UserManagement.Email')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "email",
        modelValue: _ctx.value.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.email) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.email.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        style: {"text-transform":"lowercase"}
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
            (_ctx.v$.email.email.$invalid)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.Email')), 1)
                ], 64))
              : (_ctx.v$.email.$invalid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.UserManagement.Email')})), 1)
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.Login.Password')) + " *", 1),
      _createVNode(_component_Password, {
        id: "password",
        modelValue: _ctx.value.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.password) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.password.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        feedback: false,
        toggleMask: ""
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.password.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Login.Password')})), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}